// extracted by mini-css-extract-plugin
export var truncate = "_12-0";